<template>
    <span>
        <router-link
            v-if="showEdit"
            :to="`/${organizationSlug}/configuration-sets/${configurationSetId}/distributions/${row.id}/edit`"
            class="action icon-edit"
            title="Edit"
            :data-test-id="`row-${row.id}-action-edit`"
        />
        <router-link
            v-if="showCopy"
            :to="`/${organizationSlug}/configuration-sets/${configurationSetId}/distributions/create?cloneId=${row.id}`"
            class="action icon-copy"
            title="Copy"
            :data-test-id="`row-${row.id}-action-copy`"
        />
        <a
            v-if="showDelete"
            :data-test-id="`row-${row.id}-action-delete`"
            class="delete icon-delete"
            href="#"
            title="Delete"
            @click.prevent="deleteDistribution()"
        />
    </span>
</template>

<script>
import canConfirm from '@/mixins/canConfirm'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'
import canToast from '@/mixins/canToast'
import ConfigurationSetDistributionStatuses from '@/constants/configuration-set-distribution-statuses.js'

export default {
    components: {},

    mixins: [canConfirm, needsOrganizationSlug, canToast],

    props: {
        row: {
            type: Object,
            required: true,
        },
    },

    emits: ['reload'],

    data() {
        const { hasPermission } = this.$store.getters
        const showDelete =
            hasPermission('delete configuration sets') &&
            ConfigurationSetDistributionStatuses[this.row.status] === ConfigurationSetDistributionStatuses.SCHEDULED
        const showEdit =
            hasPermission('update configuration sets') &&
            ConfigurationSetDistributionStatuses[this.row.status] === ConfigurationSetDistributionStatuses.SCHEDULED
        const showCopy =
            hasPermission('create configuration sets') &&
            ConfigurationSetDistributionStatuses[this.row.status] !== ConfigurationSetDistributionStatuses.SCHEDULED

        return {
            showCopy,
            showDelete,
            showEdit,
            configurationSetId: this.$route.params.id,
        }
    },

    methods: {
        deleteDistribution() {
            this.confirmDelete().then((willDelete) => {
                if (willDelete === true) {
                    this.$http
                        .delete(
                            `${this.organizationSlug}/configuration-sets/` +
                                `${this.configurationSetId}/distributions/${this.row.id}`
                        )
                        .then(() => {
                            this.toast(`Configuration Set Distribution successfully deleted!`)
                            this.$emit('reload')
                        })
                        .catch((error) => {
                            this.toast(`Could not delete Configuration Set Distribution`, 'error')
                        })
                }
            })
        },
        confirmDelete() {
            return this.confirm({
                message: 'Are you sure you want to delete this scheduled Distribution? This action cannot be undone.',
                acceptLabel: 'Delete',
                danger: true,
            })
        },
    },
}
</script>
